import { render, staticRenderFns } from "./ScreenDistribuidor.vue?vue&type=template&id=b2eee230&scoped=true"
import script from "./ScreenDistribuidor.vue?vue&type=script&lang=js"
export * from "./ScreenDistribuidor.vue?vue&type=script&lang=js"
import style0 from "./ScreenDistribuidor.vue?vue&type=style&index=0&id=b2eee230&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2eee230",
  null
  
)

export default component.exports